import { Module } from 'vuex'
import { RootState } from '@/store/index'
import { mutations } from '@/store/modules/orderSummary/mutations'
import { IOrderSummaryState, initialState } from '@/store/modules/orderSummary/state'

export * from '@/store/modules/orderSummary/state'

export const store: Module<IOrderSummaryState, RootState> = {
  state: initialState,
  mutations
}
